import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-relatorio-controle-interno',
  templateUrl: './relatorio-controle-interno.component.html',
  styleUrls: ['./relatorio-controle-interno.component.css']
})
export class RelatorioControleInternoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
